<template>
  <div class="tiktok-analytics-public-chart">
    <el-tabs v-model="activeTab">
      <el-tab-pane class="graph-container" label="キャンペーン" name="campaigns">
        <TikTokAnalyticsPublicCampaign></TikTokAnalyticsPublicCampaign>
      </el-tab-pane>
      <el-tab-pane class="graph-container" label="トラフィックソース" name="applicantFollowers">
        <TikTokAnalyticsPublicTrafficSource></TikTokAnalyticsPublicTrafficSource>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

import TikTokAnalyticsPublicCampaign from '@/client/features/tiktok_analytics_public/tiktok_analytics_public_campaign'
import TikTokAnalyticsPublicTrafficSource from '@/client/features/tiktok_analytics_public/tiktok_analytics_public_trafficsource'

export default defineComponent({
  components: { TikTokAnalyticsPublicCampaign, TikTokAnalyticsPublicTrafficSource },
  data() {
    return {
      activeTab: 'campaigns'
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'sass:math';
@use '@/client/assets/scss/variables.scss' as *;

.tiktok-analytics-public-chart {
  .graph-container {
    padding: $spacing-unit ($spacing-unit * 3);
    border: 1px solid $border-color;
    border-radius: math.div($spacing-unit, 2);
  }
}
</style>
